import { ApiService } from '../../../services/api_service';
import { AssistentCustomForm } from './AssistentCustomForm';
import { AssistentEntityForm } from './AssistentEntityForm';
import { AssistentItem, getAssistentConfig } from './assistent_config';
import { AssistentPruefer } from './AssistentPruefer';
import { ContextService } from '../../../services/context_service';
import { DataService } from '../../../services/data_service';
import { DatenauswertungJahrauswahlEinzeln } from '../../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { getAssistentConfigCfm } from './assistent_config_cfm';
import { getAssistentConfigVsme } from './assistent_config_vsme';
import { getAssistentConfigSteuer } from './assistent_config_steuer';
import { getCO2Scope3Auswahl } from '../functions/getCO2Scope3Auswahl';
import { getEnergiedatenAuswahl } from '../functions/getEnergiedatenStructure';
import { getErrorLevelKey } from '../../../core/forms/helpers/errorLevelTools';
import { getVSMEAuswahl } from './assistent_config_vsme';
import { getWZ } from '../../../main/functions/getGewerk';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as Moment from 'moment';
import { ProgressBar } from './ProgressBar';
import * as React from 'react';
import { renderText } from './assistent_helpers';
import { RoutingIDs } from '../../../helpers/RoutingIDs';
import Select from 'react-select';
import { StructureService } from '../../../services/structure_service';
import style from './Assistent.less';
import styleBreadcrumb from '../../start/BreadcrumbNavigation.less';
import styleWForm from '../../../core/forms/style/WForm.less';
import styleSubHeader from '../../start/SubHeader.less';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormFieldSelectOption } from '../../../core/forms/fields/WFormFieldSelect';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';
import classNames from 'classnames';
import { i18n } from '../../../i18n/i18n';
import * as config from '../../../wips.config.js';
import { getAssistentConfigVsmeOld } from './assistent_config_vsme_old';
import { WVideoIcon } from '../../../core/elements/WVideoIcon';
// import { sortObjectArray } from '../../../main/functions/sortObjectArray';

interface AssistentProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortPreset?: number;
    jahrPreset?: number;
    dialogMode?: boolean;
    setOnClickNaviBtns?: (onClickNaviBackBtn: () => void, onClickNaviNextBtn: () => void) => void;
    unsetOnClickNaviBtns?: () => void;
}

interface AssistentState {
    runState: string; // "start" = Vor Durchführung, "running" = Während Durchführung, "done" = End-Seite
    runIndex: number; // Index des aktuellen Items aus der Config
    itemsDone: boolean[]; // Damit wir wissen, ob "Weiter" zulässig ist
    // Für Jahresauswahl:
    jahr: number;
    jahrMin: number;
    jahrMax: number;
    startjahr: number;
    // Datenhaltung --> das sind nur Daten die wir im Verlauf der Eingabe brauchen, z.B. flags
    datenhaltung: any;
    standortSelected: any;
    pruefState: any;
    manualRedraw: number;
    infoMsg: string;
    lastSave: number;
    config: AssistentItem[];
    itemUpdateKey: string;
    mode: string;
    forceChoice: boolean;
    foldedGroups: any;
    onFormSaving?: boolean;
    currentGliederung: number;
    currentGliederungState: string; // open | collapsed
}

export class Assistent extends React.Component<AssistentProps, AssistentState> {

    constructor(props: any) {
        super(props);
        const konfig = props.data[IDs.ENT_KONFIGURATION];
        const jahrMax = Moment().year();
        let jahrMin = 2015;
        // let jahrMin = 2010;
        if (konfig && konfig[0] && konfig[0].startjahr_datenerfassung && konfig[0].startjahr_datenerfassung > 1900) {
            jahrMin = konfig[0].startjahr_datenerfassung < jahrMin ? jahrMin : 2015;
        }
        // console.info('START', konfig[0].startjahr_datenerfassung, props.data.first_year, props.data.last_year, jahrMin, props.data);
        const jahrStartDateneingabe = konfig[0].startjahr_datenerfassung;

        if (Assistent.lastState && this.apiService.getMandantKey() === Assistent.lastMandant) {
            // this.state = { ...JSON.parse(Assistent.lastState), datenhaltung: this.getDatenhaltung() };
            this.state = { ...(Assistent.lastState || {}), datenhaltung: this.getDatenhaltung() };
        } else {
            this.state = {
                runState: 'start',
                runIndex: -1,
                itemsDone: [],
                jahr: jahrMax - 1,
                jahrMin: jahrMin,
                jahrMax: jahrMax,
                datenhaltung: this.getDatenhaltung(),
                standortSelected: undefined,
                pruefState: undefined,
                manualRedraw: 0,
                config: undefined,
                lastSave: undefined,
                infoMsg: '',
                itemUpdateKey: null,
                startjahr: jahrStartDateneingabe,
                mode: 'classic',
                forceChoice: true,
                foldedGroups: {},
                currentGliederung: 1,
                currentGliederungState: 'collapsed'
            };
        }

        this.contentMain = React.createRef();
        this.prevItem = this.prevItem.bind(this);
        this.nextItem = this.nextItem.bind(this);
        this.onClickStart = this.onClickStart.bind(this);
        this.onFormReady = this.onFormReady.bind(this);
        this.processInterval = this.processInterval.bind(this);
        this.restoreScrollTop = this.restoreScrollTop.bind(this);
        this.setStartjahrDatenerfassung = this.setStartjahrDatenerfassung.bind(this);
        this.setStartjahrDatenerfassungNow = this.setStartjahrDatenerfassungNow.bind(this);
        this.setRunStateStart = this.setRunStateStart.bind(this);

        this.isAdmin = this.apiService.isAdmin();
        this.bereichKey = this.apiService.getBereichKey();
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private static lastState: any = undefined;
    private static lastMandant: any = undefined;
    private lastHandle: number = undefined;
    private lastGliederungKey: string = undefined;
    private isAdmin = false;
    private bereichKey: string;
    private routing: any = null;
    private konfiguration_check: string = undefined;
    private intervalHandle: number = undefined;
    private contentMain: any;
    private domId = 'assistent_form_div';
    private domIdMenue = 'assistent_form_div_menue';
    private scrollTop: any;
    private scrollTopMenue: any;
    private varianten: any[] = [
        { key: 'classic', name: 'E-Tool classic' },
        { key: 'cfm', name: 'CO₂-Fußabdruck' },
        { key: 'steuer', name: 'Strom- und Energiesteuer' },
        { key: 'nachhaltigkeit', name: 'Nachhaltigkeit' },
        { key: 'vsme', name: 'VSME-Modul' }
    ];

    componentDidMount(): void {
        this.setState({ config: undefined }, () => this.setConfig());
        this.checkRouting();
        this.setModulSelected();
        this.intervalHandle = window.setInterval(() => this.processInterval(), 1000);
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        // itemUpdateKey kontrolliert ob sich Energieträger oder Einheit geändert haben. Bei der Änderung AssistentConfig neu laden.
        // Einzelverbräuche erscheint / verschwindet sofort
        if (prevState.itemUpdateKey !== this.state.itemUpdateKey) {
            this.setConfig();
        }
        if (prevState.runIndex !== this.state.runIndex) {
            this.onChangeRunIndex(prevState.runIndex);
        }
        const data: any = this.props.data || {};
        if (typeof data.first_year !== 'undefined') {
            const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
            let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
            jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
            if (jahrMin !== this.state.jahrMin) {
                this.setState({ jahrMin, startjahr: jahrMin });
            }
        }
        this.checkRunIndex(prevState);
        this.setModulSelected();

        if (typeof this.props.setOnClickNaviBtns === 'function') {
            // this.props.setOnClickNaviBtns(this.prevItem, this.nextItem);
            // -> Die Initialisierungsinstanz wird immer verwendet -> Probleme beim Tab-Wechseln.
            // Die aktuelle Instanz wird verwendet -> In Ordnung.
            this.props.setOnClickNaviBtns(
                () => this.prevItem(),
                () => this.nextItem()
            );
        }
    }

    componentWillUnmount(): void {
        Assistent.lastState = { ...this.state };
        Assistent.lastMandant = this.apiService.getMandantKey();
        window.clearInterval(this.intervalHandle);

        if (typeof this.props.unsetOnClickNaviBtns === 'function') {
            this.props.unsetOnClickNaviBtns();
        }
    }

    setModulSelected() {
        const { data } = this.props;
        if (data.MODUL_SELECTED !== this.state.mode) {
            const varianteFnd = this.varianten.find((v: any) => v.key === data.MODUL_SELECTED);
            if (varianteFnd) {
                this.setState({ mode: varianteFnd.key }, this.setRunStateStart);
            }
        }
    }

    getModeConfig(clearPruefState?: () => void) {
        const mode = this.state.mode;
        switch (mode) {
            case 'cfm':
                return getAssistentConfigCfm(
                    this.state.standortSelected, this.props.data, this.state.jahr, this.dataService, this.triggerService,
                    this.props.onRoutingChange, clearPruefState, this.isAdmin, this.bereichKey, this.routing
                );
            case 'vsme':
                if(config.instance === 'lux') { 
                    return getAssistentConfigVsme(
                        this.state.standortSelected, this.props.data, this.state.jahr, this.dataService, this.triggerService, this.structureService,
                        this.props.onRoutingChange, clearPruefState, this.isAdmin, this.bereichKey, this.routing
                    );
                } else {
                    return getAssistentConfigVsmeOld(
                        this.state.standortSelected, this.props.data, this.state.jahr, this.dataService, this.triggerService, this.structureService,
                        this.props.onRoutingChange, clearPruefState, this.isAdmin, this.bereichKey, this.routing
                    );
                }
            case 'steuer':
                return getAssistentConfigSteuer(
                    this.state.standortSelected, this.props.data, this.state.jahr, this.dataService, this.triggerService,
                    this.props.onRoutingChange, clearPruefState, this.isAdmin, this.bereichKey, this.routing
                );
            default:
                return getAssistentConfig(
                    this.state.standortSelected, this.props.data, this.state.jahr, this.dataService, this.triggerService,
                    this.props.onRoutingChange, clearPruefState, this.isAdmin, this.bereichKey, this.routing
                );
        }
    }

    setConfig(setState = true) {
        const config = this.getModeConfig(() => this.setState({ pruefState: undefined }));
        if (setState) {
            const routing: any = this.routing || {};
            const entity: string = routing.entity || null;
            const jahr: number = +routing.jahr || null;
            const key: string = routing.key || null;
            const standort: any = routing.standort || null;
            const checkKey: any = key && typeof this.state.datenhaltung[key] !== 'undefined'
                ? { datenhaltung: { ...this.state.datenhaltung, [key]: true } } : null;
            this.setState(
                { config, ...(jahr && { jahr }), ...(((key || entity) && standort) && { standortSelected: standort }), ...checkKey },
                ((key || entity) && standort)
                    ? () => {
                        const config = this.getModeConfig();
                        this.onClickStart();
                        this.setState({ config }, () => {
                            const runIndex: number = (this.state.config || [])
                                .findIndex((item: any) => (key && item.configFlag === key) || (!key && item.entity === entity));
                            this.setState({ runIndex }, () => this.routing = null);
                        });
                    }
                    : null
            );
        }
        return config;
    }

    checkRunIndex(prevState: any): void {
        const { runIndex, config } = this.state;
        if (Array.isArray(prevState.config) && Array.isArray(config) && runIndex >= 0) {
            if (prevState.config[runIndex] && config[runIndex] && prevState.config[runIndex].name !== config[runIndex].name) {
                const currIndex = config.findIndex((c: any) => c.name === prevState.config[runIndex].name);
                // console.log(runIndex, currIndex);
                if (currIndex >= 0 && this.state.runIndex !== currIndex) {
                    this.setState({ runIndex: currIndex });
                }
            }
        }
    }

    onChangeRunIndex(prevRunIndex: number): void {
        if (Array.isArray(this.state.config) && this.state.config[prevRunIndex]) {
            const prevItem = this.state.config[prevRunIndex];
            if (typeof prevItem.callOnChangeRunIndex === 'function') {
                prevItem.callOnChangeRunIndex();
            }
        }
    }

    getDatenhaltung(): any {
        return {
            checkCfmMotivation: true,
            checkVeranstaltungen: true,
            checkStandorte: true,
            checkConfig: true,
            checkUnternehmen: true,
            doImport: true
        };
    }

    processInterval(): void {
        let msg = '';
        if (this.state.lastSave) {
            msg = 'Ihre Eingaben wurden automatisch gespeichert!';
        }
        this.setState({ infoMsg: msg });
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const entity: string = (routing.entities || [])[0] || null;
        const jahr: number = +routing.jahr || null;
        const key: string = routing.key || null;
        const path: string = routing.path || null;
        const standort: any = routing.standort
            ? ((this.props.data || {})[IDs.ENT_STANDORT] || []).find((item: any) => item.tid === routing.standort) || null : null;
        const tid: number = routing.tid || null;
        this.routing = { entity, jahr, ...(key && { key }), ...(path && { path }), standort, ...(tid && { tid }) };
        this.props.onRoutingChange({});
    }

    nextItem(): void {
        const { runIndex, runState } = this.state;
        if (runState !== 'running' && runState !== 'done') {
            alert('Bitte starten Sie zunächst die Dateneingabe!');
            return;
        }
        // console.log('NextItem:', runIndex, runState);
        const runningItem = this.state.config[runIndex];
        if (runningItem && runningItem.blockContinue) {
            alert(runningItem.blockText);
            return;
        }
        const itemsDone = this.state.itemsDone;
        if (runIndex !== -1) {
            itemsDone[runIndex] = true;
        }
        if (this.state.config.length > runIndex + 1) {
            this.setState({ runIndex: runIndex + 1, itemsDone }, () => {
                // Wenn das neue Item deaktiviert ist --> nochmal next
                const runIndexNew = this.state.runIndex;
                if (this.state.config && this.state.config[runIndexNew]) {
                    const currentItem = this.state.config[runIndexNew];
                    const deactivate = currentItem.configFlag && this.state.datenhaltung[currentItem.configFlag] === false;
                    if (deactivate) {
                        this.nextItem();
                    }
                }
            });
        } else {
            // Wir sind am Ende
            this.setState({ runState: 'done', itemsDone });
        }
    }

    prevItem(): void {
        const { runIndex, runState } = this.state;
        if (runState !== 'running' && runState !== 'done') {
            alert('Bitte starten Sie zunächst die Dateneingabe!');
            return;
        }
        // console.log('prevItem:', runIndex, runState);
        if (runIndex > 0) {
            const itemsDone = this.state.itemsDone;
            this.setState({ runIndex: runIndex - 1, itemsDone }, () => {
                // Wenn das neue Item deaktiviert ist --> nochmal previous
                const runIndexNew = this.state.runIndex;
                if (this.state.config && this.state.config[runIndexNew]) {
                    const currentItem = this.state.config[runIndexNew];
                    const deactivate = currentItem.configFlag && this.state.datenhaltung[currentItem.configFlag] === false;
                    if (deactivate) {
                        this.prevItem();
                    }
                }
            });
        } else {
            // Wir sind wieder am Anfang
            this.setRunStateStart();
        }
    }

    getKonfigKey(): string {
        const modulSelected = this.props.data.MODUL_SELECTED;
        const konfiguration: any = (this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const enableErneuerbareEnergien: boolean = konfiguration.daten_erneuerbare_energien_orig === 1;
        const enableMaschinen: boolean = konfiguration.daten_maschinen_orig === 1;
        const enableFahrzeuge: boolean = konfiguration.daten_fahrzeuge_orig === 1;
        const enable_technik = enableErneuerbareEnergien || enableFahrzeuge || enableMaschinen;
        const enableMehrereStandorte: boolean = konfiguration.mehrere_standorte_orig === 1;
        const alternatives_system: boolean = konfiguration.mehrere_standorte_orig === 1;
        const disabledCO2Komplex: boolean = !IDs.FLAG_ENABLE_SCOPE3 || konfiguration.co2_fussabdruck_orig !== 1;
        const disabledCO2KomplexSachanlagen: boolean = !IDs.FLAG_ENABLE_SCOPE3 || konfiguration.co2_fussabdruck_modus !== 'ghg';
        const showSachanlagen: boolean = /*IDs.FLAG_ENABLE_SCOPE3 && */konfiguration.co2_fussabdruck_sachanlagen_orig === 1;
        // const berater_zugriff: boolean = konfiguration.berater_zugriff_orig === 1;
        const enableVeranstaltungen: boolean = konfiguration.veranstaltungen_orig === 1;
        const gliederung_key = this.state.config.map((item: AssistentItem, idx: number) => item ? item.gliederung : '').join('_');
        const wz_id = getWZ(this.props.data);
        const dateneingabeVariante = konfiguration.dateneingabe_variante || '';

        // Unternehmensdaten
        const unternehmensdaten: any = (this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {};
        const showTochtergesellschaften: boolean = unternehmensdaten.hat_tochtergesellschaften_orig === 1;

        // Auswahl
        const scope3_key = this.state.standortSelected
            ? getCO2Scope3Auswahl(this.props.data, this.state.standortSelected, this.state.jahr, this.state.jahr).join('_') : '';
        const energiedaten_auswahl_key = this.state.standortSelected
            ? getEnergiedatenAuswahl(this.props.data, this.state.standortSelected.tid, this.state.jahr).join('_') : '';

        // VSME
        const vsme_dynamic_key = dateneingabeVariante === 'vsme' && this.state.standortSelected ?
            getVSMEAuswahl(this.props.data, this.state.standortSelected.tid, this.state.jahr).join('_') : '';
        const vsme_modul = dateneingabeVariante === 'vsme' && this.state.standortSelected && this.props.data && this.props.data[IDs.ENT_VSME_B1] &&
            this.props.data[IDs.ENT_VSME_B1].length > 0 ? this.props.data[IDs.ENT_VSME_B1][0].modul : '';
        const vsme_b1_bericht = dateneingabeVariante === 'vsme' && this.state.standortSelected && this.props.data && this.props.data[IDs.ENT_VSME_B1] &&
            this.props.data[IDs.ENT_VSME_B1].length > 0 ? this.props.data[IDs.ENT_VSME_B1][0].bericht : '';
        const vsme_b3_e_tool_nutzung = dateneingabeVariante === 'vsme' && this.state.standortSelected && this.props.data && this.props.data[IDs.ENT_VSME_B3] &&
            this.props.data[IDs.ENT_VSME_B3].length > 0 ? this.props.data[IDs.ENT_VSME_B3][0].e_tool_nutzung : '';
        const vsme_bpm3_ziele = this.contextService.get(IDs.CONTEXT_KEYS.AssistentConfigBpm3Dialog) || '';

        // Steuer
        const enableEnergiesteuerrueckerstattung: boolean = konfiguration.energiesteuerrueckerstattung_orig === 1;

        return [
            modulSelected,
            dateneingabeVariante,
            enableErneuerbareEnergien,
            enableMehrereStandorte,
            alternatives_system,
            wz_id,
            enable_technik,
            gliederung_key,
            disabledCO2Komplex,
            disabledCO2KomplexSachanlagen,
            showSachanlagen,
            enableVeranstaltungen,
            // Unternehmensdaten
            showTochtergesellschaften,
            // Auswahl
            scope3_key,
            energiedaten_auswahl_key,
            // VSME
            vsme_dynamic_key,
            vsme_modul,
            vsme_b1_bericht,
            vsme_b3_e_tool_nutzung,
            vsme_bpm3_ziele,
            // Steuer
            enableEnergiesteuerrueckerstattung
        ].join('_');
    }

    getProgress(): number[] {
        const config: any[] = this.state.config || [];
        const max: number = config.filter((item: any) => (item || {}).type === 'EntityForm').length;
        const min: number = 0;
        const value: number = this.state.runState !== 'done'
            ? (this.state.runIndex >= 0
                ? config.slice(0, this.state.runIndex).filter((item: any) => (item || {}).type === 'EntityForm').length : 0)
            : max;

        return [min, value, max];
    }

    render(): JSX.Element {
        if (!this.state.config) {
            return <div>Konfiguration wird vorbereitet ...</div>; // render hier abbrechen
        }
        const k_check = this.getKonfigKey();
        if (this.konfiguration_check === undefined) {
            this.konfiguration_check = k_check;
        } else if (this.konfiguration_check !== k_check) {
            this.konfiguration_check = k_check;
            const config = this.setConfig(false);
            this.storeScrollTop();
            this.storeMenueScrollTop();
            //
            // WKETOOL-170:
            // Konfiguration: Beim Umstellen von „Ja“ auf „Nein“ oder vice versa springt/glitcht der Bildschirm bei den Fragen nach Standort / Erneuerbare / komp. bzw. det. Erfassung und Scope 3;
            // sicherlich weil dann neu geladen wird, um die entsprechenden zusätzlichen Aspekte/Abfragen in der Seitenleiste darzustellen.
            // Das ist kein ernsthaftes Problem, wirkt aber nicht sehr professionell. Lässt sich das ggf. verbessern?
            //
            const runIndex = this.state.runIndex;
            if (this.state.config && this.state.config[runIndex] && this.state.config[runIndex].entity === IDs.ENT_KONFIGURATION) {
                this.setState({ config });
            } else {
                this.setState({ config: undefined }, () => this.setState({ config }));
            }
        }

        const konfiguration: any = (this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const modus: string = konfiguration.co2_fussabdruck_modus || '';
        const modul = konfiguration.dateneingabe_variante || '';

        return (
            <div
                id={this.domId}
                className='cont-assistent'
                style={{ display: 'flex', flex: 1, flexDirection: 'row', minHeight: 0 }}
                key={`assistant_${modus}_${modul}`}
            >
                {this.renderMenue()}
                {this.renderContent()}
            </div>
        );
    }

    renderMenue(): JSX.Element {
        const runState = this.state.runState;
        const runIndex = this.state.runIndex;
        const currentItem = this.state.config[runIndex];
        const gliederung_key = this.state.config.map((item: AssistentItem, idx: number) => item ? item.gliederung : '').join('_');
        const updateGliederung = this.lastGliederungKey && gliederung_key !== this.lastGliederungKey;
        const currentGliederung = currentItem && typeof currentItem.gliederung === 'string'
            ? +currentItem.gliederung.split('.')[0]
            : 1;


        if (updateGliederung) {
            window.setTimeout(() => this.setState({ pruefState: undefined }), 100);
        }
        this.lastGliederungKey = gliederung_key;
        this.restoreMenueScrollTop();

        return <div
            id={this.domIdMenue}
            className={style.menue}
        >
            {this.renderModusBeendenAndInfo()}
            {(!config.instance || config.instance != 'lux' /*DIRTY - später woanders hin ???*/) && this.renderMenueStart()}
            {
                this.state.config.map((item: AssistentItem, idx: number) => {
                    return this.renderMenueItem(item, idx, (runState === 'running' && item === currentItem), currentGliederung)
                })
            }
            {this.renderLegende()}
            {this.state.runState === 'running' && !this.state.pruefState &&
                <AssistentPruefer
                    data={this.props.data}
                    jahr={this.state.jahr}
                    standortSelected={this.state.standortSelected}
                    items={this.state.config}
                    pruefState={this.state.pruefState}
                    onPruefStateChange={(pruefState: any) => this.setState({ pruefState })}
                />
            }
        </div>;
    }

    renderLegende(): JSX.Element {
        return <div className={style.menueLegende}>
            <div style={{ fontWeight: 600 }}>Info-Symbole neben Bereichen:</div>
            <div className={style.menueLegendeRow}>
                <div className={classNames(style.menueIndicator, style.menueIndicatorGreen)}>✓</div>
                <div style={{ marginLeft: 5 }}>Eingaben sind vollständig</div>
            </div>
            <div className={style.menueLegendeRow}>
                <div className={classNames(style.menueIndicator, style.menueIndicatorYellow)}>?</div>
                <div style={{ marginLeft: 5 }}>Eingaben sind unvollständig</div>
            </div>
            <div className={style.menueLegendeRow}>
                <div className={classNames(style.menueIndicator, style.menueIndicatorRed)}>!</div>
                <div style={{ marginLeft: 5 }}>Eingaben sind fehlerhaft</div>
            </div>
        </div>;
    }

    renderMenueStart() {
        // const isCurrent: boolean = this.state.runState === 'start';
        const isCurrent: boolean = this.state.runIndex < this.getStartIndex();
        const isVsme: boolean = this.state.mode === 'vsme';
        let currentGliederungState = this.state.currentGliederungState;

        return <div
            className={classNames(
                style.menueItemLevel1,
                isCurrent ? style.menueItemCurrentLevel1 : undefined
            )}
            key='menue_start'
            onClick={
                () => {
                    if (isCurrent) {
                        currentGliederungState = this.state.currentGliederungState !== 'open' ? 'open' : 'collapsed';
                    }
                    this.setState({
                        runState: this.state.runState !== 'running' ? 'start' : 'running',
                        datenhaltung: this.getDatenhaltung(),
                        runIndex: -1,
                        itemsDone: [],
                        pruefState: undefined,
                        forceChoice: true,
                        // currentGliederungState,
                        ...(!isVsme && { currentGliederungState }),
                        // currentGliederung: 1
                        ...(!isVsme && { currentGliederung: 1 })
                    });
                }
            }
        >
            <div>
                {`${this.state.mode !== 'vsme' ? '1. ' : ''}${i18n('Allgemeine Unternehmensangaben', 'sys')}`}
            </div>
            <div className={style.menueIndicator} style={{ border: 0 }}>
                {isVsme ? '' : (isCurrent && currentGliederungState === 'open' ? '▼' : '▶')}
            </div>
        </div>;
    }

    setRunStateStart() {
        this.setState({
            runState: 'start',
            datenhaltung: this.getDatenhaltung(),
            runIndex: 0,
            itemsDone: [],
            pruefState: undefined,
            forceChoice: true
        });
    }

    renderMenueItem(item: AssistentItem, idx: number, isCurrent: boolean, currentGliederung: number): JSX.Element {
        if (!item) {
            return <div />;
        }
        const deactivate = item.configFlag && this.state.datenhaltung[item.configFlag] === false;
        const colText = this.state.runState === 'running' && deactivate && '#aaa';
        const title = `${i18n(item.name || '', `entity.${item.entity}`)}`;

        const foldedGroups = this.state.foldedGroups || {};
        if (item.group && foldedGroups[item.group]) {
            return null;
        }

        let foldBtn;
        if (item.collapsible) {
            let auswahl;
            if (this.state.mode === 'vsme') {
                auswahl = getVSMEAuswahl(this.props.data, (this.state.standortSelected || {}).tid, this.state.jahr, null, null, item.collapsible);
            }
            const exception = ['vsme_basis', 'vsme_basis_b1', 'vsme_basis_b3'];
            if (!auswahl || auswahl.length > 0 || exception.indexOf(item.collapsible) !== -1) {
                foldBtn = <div
                    title={foldedGroups[item.collapsible] ? 'Ausklappen' : 'Einklappen'}
                    style={{ padding: '0 10px', fontSize: '1.3em', fontWeight: 'bold' }}
                    onClick={() => {
                        const collapsibleGroups = this.getCollapsibleGroups(item.collapsible);
                        if (collapsibleGroups.length > 0) {
                            const isFolded = foldedGroups[collapsibleGroups[0]];
                            collapsibleGroups.forEach((grp: string) => foldedGroups[grp] = !isFolded);
                            this.setState({ foldedGroups });
                        }
                    }}
                >
                    {foldedGroups[item.collapsible] ? '▷'/*String.fromCharCode(43)*/ /*+*/ : '▽'/*String.fromCharCode(8722)*/ /*-*/}
                </div>;
            }
        }

        const isLevel1 = typeof item.gliederung === 'string' && item.gliederung.endsWith('.');
        const itemGliederung = typeof item.gliederung === 'string'
            ? +item.gliederung.split('.')[0]
            : 1;
        const currentGliederungState = this.state.currentGliederungState;
        const isCollapsedGroup = itemGliederung !== currentGliederung || (itemGliederung === currentGliederung && currentGliederungState !== 'open');
        let titleGliederung: string = item.gliederung;

        if (this.state.mode === 'vsme'/* && isLevel1*/) {
            foldBtn = null;
            titleGliederung = item.gliederung2 || null;
        }

        if (!isLevel1 && isCollapsedGroup) {
            return null;
        }

        return <div
            className={classNames(
                isLevel1 ? style.menueItemLevel1 : style.menueItemLevel2,
                isCurrent
                    ? isLevel1 ? style.menueItemCurrentLevel1 : style.menueItemCurrent
                    : undefined
            )}
            key={`menue_item_${idx}`}
            style={{ color: colText }}
            ref={(ref: any) => this.setMenueNodeTitle(ref, title)}
            onClick={() => {
                if (item.disableOnClick) {
                    return;
                }
                if (this.state.runState !== 'running' && this.state.runState !== 'done') {
                    alert('Bitte starten Sie zunächst die Dateneingabe!');
                    return;
                }
                const runIndex = this.state.runIndex;
                const runningItem = this.state.config[runIndex];
                if (runningItem && runningItem.blockContinue) {
                    alert(runningItem.blockText);
                    return;
                }

                if (!isCollapsedGroup && isLevel1) { // beim Zuklappen nicht in den Bereich springen
                    this.setState({ currentGliederungState: 'collapsed' });
                    return;
                } else if (isLevel1 && itemGliederung === currentGliederung && this.state.currentGliederungState !== 'open') {
                    this.setState({ currentGliederung: itemGliederung, currentGliederungState: 'open' });
                } else if (isLevel1 && itemGliederung !== currentGliederung) {
                    this.setState({ currentGliederung: itemGliederung, currentGliederungState: 'open' });
                }

                if (!deactivate && this.state.runState === 'running') {
                    this.contextService.set('WHelpIconLastAutoKey', undefined);
                    this.setState({ runIndex: idx });
                }
            }}
        >
            <div style={{ overflow: 'hidden', display: 'flex', width: 'calc(100% - 20px)' }}>
                <div style={{
                    display: 'flex', flexDirection: 'row',
                    ...(item.disableOnClick && { cursor: 'default' })
                }}>
                    {titleGliederung ? <div style={{ marginRight: 5 }}>{titleGliederung}</div> : null}
                    <div style={{ whiteSpace: 'break-spaces' }}>{title}</div>
                </div>
                {foldBtn}
            </div>
            {this.renderIndicator(item, isCollapsedGroup)}
        </div>;
    }

    renderMenueCheckbox(item: AssistentItem): JSX.Element {
        const input = <input
            style={{ marginTop: 1 }}
            checked={this.state.datenhaltung[item.configFlag] !== false}
            type='checkbox'
            onChange={(evt: any) => {
                const datenhaltung = this.state.datenhaltung;
                datenhaltung[item.configFlag] = evt.target.checked;
                this.setState({ datenhaltung });
            }}
        />;
        return <div>{input}</div>;
    }

    renderGroupIndicator(group: string): JSX.Element {
        const { config } = this.state;
        const stati: any = {};
        (config || []).filter((c: any) => c.group === group).forEach((c: any) => {
            const indic = this.getIndicator(c);
            if (indic.className) {
                if (!stati[indic.className]) {
                    stati[indic.className] = 0;
                }
                stati[indic.className] += parseInt(indic.anzahl, 10);
            }
        });
        const cssCls = [style.menueIndicatorRed, style.menueIndicatorYellow, style.menueIndicatorGreen, style.menueIndicatorGrey];
        const fndCls = cssCls.find((cls: string) => stati[cls] > 0);
        if (fndCls) {
            return <div className={fndCls}>{stati[fndCls]}</div>;
        }
        return null;
    }

    getIndicator(item: AssistentItem): any {
        const deactivate = item.configFlag && this.state.datenhaltung[item.configFlag] === false;
        let className: string;
        let anzahl = '';
        if (deactivate) {
            className = 'menueIndicatorGrey';
        } else if (item.type === 'EntityForm') {
            const pruefState = this.state.pruefState;
            const pruefItem = pruefState && pruefState[item.entity] ? pruefState[item.entity] : undefined;
            let forceGreen = false;
            if (item.entity === IDs.ENT_KENNZIFFERN_GENERATED && pruefItem && pruefItem.anzahl > 0) {
                forceGreen = true;
            }
            anzahl = pruefItem ? pruefItem.anzahl : '';
            if (pruefItem) {
                if (pruefItem.anzahl === 0) {
                    className = 'menueIndicatorYellow';
                } else {
                    // Jetzt prüfen wir, wieviele i.O. sind
                    let cntOK = 0;
                    pruefItem.pruefResult.forEach((res: any) => {
                        const isValid: boolean = !Object.values(res).some((value: string) => getErrorLevelKey(value) !== 'warning');
                        if (Object.keys(res).length === 0 || isValid) {
                            cntOK++;
                        }
                    });
                    if (cntOK === 0 && !forceGreen) {
                        className = 'menueIndicatorRed';
                    } else if (cntOK === pruefItem.anzahl || forceGreen) {
                        className = 'menueIndicatorGreen';
                    } else {
                        className = 'menueIndicatorRed';
                    }
                }
            }
        }
        return { className, anzahl };
    }

    renderIndicator(item: AssistentItem, isCollapsedGroup: boolean): JSX.Element {
        // Deaktiviert / Ausgeblendet
        if (item.disableIndicator || item.disablePruefer) {
            // || this.state.runState === 'start'
            return null;
        }
        // Faltbar
        const isLevel1 = typeof item.gliederung === 'string' && item.gliederung.endsWith('.');
        const hasChildren = (this.state.config || []).find((i: any) => i.gliederung !== item.gliederung && (i.gliederung || '').startsWith(item.gliederung));

        if (isLevel1 && hasChildren) {
            return <div className={style.menueIndicator} style={{ border: 0 }}>{isCollapsedGroup ? '▶' : '▼'}</div>;
        }
        // CustomElement / CustomGroupElement
        if (item.type === 'CustomElement' || item.type === 'CustomGroupElement') {
            return null;
        }
        const indic = this.getIndicator(item);
        let zeichen: string;
        if (indic.className === 'menueIndicatorGreen') {
            zeichen = '✓';
        } else if (indic.className === 'menueIndicatorYellow') {
            zeichen = '?';
        } if (indic.className === 'menueIndicatorRed') {
            zeichen = '!';
        }
        if (zeichen) {
            return <div className={classNames(style.menueIndicator, style[indic.className])}>{zeichen}</div>;
        }
        return null;
    }

    renderContent(): JSX.Element {
        const runState = this.state.runState;
        const runIndex = this.state.runIndex;
        const currentItem = this.state.config[runIndex];
        if (currentItem && runState === 'running' && this.state.datenhaltung[currentItem.configFlag] === false) {
            if (runIndex > 0) {
                this.prevItem();
            } else {
                this.nextItem();
            }
            return <div></div>;
        }

        let standort_name = '';
        let standort_typ = 'Standort';
        if (this.state.runState === 'running' && this.state.standortSelected && Array.isArray(this.props.data[IDs.ENT_STANDORT])) {
            const found = this.props.data[IDs.ENT_STANDORT].find((so: any) => so.tid === this.state.standortSelected.tid);
            if (found) {
                standort_name = found.name;
                if (+found.standort_typ_tid_orig === 5 || +found.standort_typ_tid_orig === 6) {
                    standort_typ = 'Veranstaltung';
                }
            }
        }

        // WKETOOL-258: Soll diese Auswahl im Redesign immer ausgeblendet werden?
        // const enableErfassungsmodus = this.apiService.getBereichKey() !== 'kultur' && this.state.mode !== 'cfm';
        const videoInfo: any = this.getVideoForItem(currentItem);
        // console.log('Videoinfo: ', videoInfo);
        return (
            <div className={style.contentOuter}>
                <div className={style.contentMain} ref={this.contentMain}>
                    <div className={currentItem && runState === 'running' ? style.assistentShadow : null}>
                        {runState === 'running' && runIndex >= 0 && currentItem && <>
                            {config?.enableVideos && videoInfo &&
                                <div
                                    className={style.startBox}
                                    style={{
                                        textAlign: 'right', width: 595, margin: 0, marginTop: 8, padding: 0, paddingRight: 10,
                                        position: 'absolute', backgroundColor: 'transparent', boxShadow: 'none'
                                    }}
                                >
                                    <WVideoIcon
                                        videoUrl={videoInfo.url}
                                        title={i18n(videoInfo.name, 'sys')}
                                        // color='var(--color-assistent-btn-color)'
                                    />
                                </div>
                            }
                            <div
                                className={classNames(styleBreadcrumb.breadcrumb_navigation, style.entityForm)}
                                style={{ marginTop: 10, marginBottom: 0, boxShadow: 'none' }}
                            >
                                <div>Eingabe</div>
                                <div>Datenerfassung</div>
                                <div>{currentItem.name || ''}</div>
                            </div>
                            </>
                        }
                        {this.state.runState === 'running' && runIndex >= 0 &&
                            <div
                                className={classNames(styleWForm.flowV2, style.entityForm)}
                                style={{
                                    marginTop: 0, marginBottom: 0, boxSizing: 'border-box', padding: '10px 24px'
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
                                        paddingBottom: 10, borderBottom: '1px dotted'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        Jahr:&nbsp;<span style={{ fontWeight: 600 }}>{this.state.jahr}</span>
                                        {this.getBackToStartButton()}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: -10 }}>
                                        {standort_typ}:&nbsp;<span style={{ fontWeight: 600 }}>{standort_name}</span>
                                        {this.getBackToStartButton()}
                                    </div>
                                </div>
                            </div>
                        }
                        {runState === 'running' && this.renderContentRunning(currentItem)}
                    </div>

                    {(runState === 'start' || runIndex === -1) && this.renderContentStart()}
                    {runState === 'running' && this.renderNaviButtons()}
                    {runState === 'done' && this.renderContentDone()}

                </div>
            </div>
        );
    }

    renderNaviButtons(): JSX.Element {
        return <div style={{
            display: 'flex', flexDirection: 'row', alignItems: 'center',
            marginLeft: 20, marginBottom: 20
        }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div
                    className={classNames(styleSubHeader.naviBtn, styleSubHeader.naviBackBtn)}
                    onClick={this.prevItem}
                />
                <div
                    className={classNames(styleSubHeader.naviBtn, styleSubHeader.naviNextBtn)}
                    onClick={this.nextItem}
                />
            </div>
        </div>;
    }

    getBackToStartButton(): JSX.Element {
        return (
            <WActionButton
                style='theme_small'
                tooltip='Jahr / Standort bearbeiten'
                label='Jahr / Standort bearbeiten'
                insideText='bearbeiten'
                action='theme_edit_blue'
                divStyle={{ marginLeft: -5 }}
                onAction={this.setRunStateStart}
            />
        );
    }

    renderContentRunning(currentItem: AssistentItem): JSX.Element {
        // console.log('CURRENTITEM', currentItem);
        if (!currentItem) {
            // console.log('No Current Item');
            return null;
        }

        const infoElement = currentItem.infoTextKey ?
            <div
                className={style.customFormInfotext}
                style={{
                    borderRadius: 'unset',
                    ...currentItem.infoTextStyle
                }}
            >
                {renderText(currentItem.infoTextKey, this.props.data)}
            </div>
            : currentItem.description;

        if (currentItem.type === 'CustomForm') {
            return <AssistentCustomForm
                data={this.props.data}
                key={`acf-${this.state.runIndex}`}
                item={currentItem}
                datenhaltung={this.state.datenhaltung}
                onDatenhaltungChange={(datenhaltung: any) => this.setState({ datenhaltung })}
            />;
        } else if (currentItem.type === 'EntityForm') {
            this.setContextKey(currentItem);
            const propsLang = this.props.data.LANGUAGE_SELECTED || 'de';
            return <div>
                {currentItem.infoTextKey &&
                    <div
                        style={{ padding: '0 15px' }}
                    >
                        {infoElement}
                    </div>
                }
                <AssistentEntityForm
                    key={`aef_${this.state.runIndex}_${propsLang}`}
                    item={currentItem}
                    data={this.props.data}
                    jahr={this.state.jahr}
                    standort={this.state.standortSelected}
                    onPruefItemChange={(datensatz: any, state: any) => this.setPruefItemChange(datensatz, state)}
                    pruefItem={this.state.pruefState ? this.state.pruefState[currentItem.entity] : undefined}
                    reCheck={(anzahl: number) => {
                        const { pruefState } = this.state;
                        if (pruefState && pruefState[currentItem.entity]) {
                            pruefState[currentItem.entity].anzahl = anzahl;
                            this.setState({ pruefState });
                        }
                    }}
                    notifySave={(t: number) => this.setState({ lastSave: t })}
                    onChangeUpdateKey={(key: string) => this.setState({ itemUpdateKey: key })}
                    scrollTop={() => {
                        if (this.contentMain && this.contentMain.current) {
                            if (!this.scrollTop) {
                                this.scrollTop = {};
                            }
                            this.scrollTop.child = 0;
                            this.contentMain.current.scrollTop = 0;
                        }
                    }}
                    onFormReady={this.onFormReady}
                    onFormSaving={(onFormSaving) => this.setState({ onFormSaving })}
                    callBeforeDelete={currentItem.callBeforeDelete}
                />
            </div>;
        } else if (currentItem.type === 'CustomElement' || currentItem.type === 'CustomGroupElement') {
            return <div style={{/* padding: '0 0 20px 20px' */ }}>
                {infoElement}
                {Array.isArray(currentItem.customElements) &&
                    currentItem.customElements.filter((ce: any) => { return ce && ce.type ? true : false; })
                }
            </div>;
        } else if (currentItem.type === 'Info') {
            return <div style={{/* padding: '0 0 20px 20px' */ }}>{infoElement}</div>;
        }
        return <div />;
    }

    setPruefItemChange(datensatz: any, state: any): void {
        // console.log('CHANGE PRÜFSTATE:', state, datensatz);
        const runIndex = this.state.runIndex;
        const currentItem = this.state.config[runIndex];
        if (this.state.pruefState) {
            const pruefState = this.state.pruefState;
            let changed = false;
            if (currentItem.type === 'EntityForm' && pruefState[currentItem.entity]) {
                // console.log('PRUEFSTATE', currentItem.entity, pruefState[currentItem.entity], pruefState);
                if (datensatz && datensatz.tid > 0) {
                    let idxFound = -1;
                    pruefState[currentItem.entity].pruefTids.forEach((tid: number, idx: number) => {
                        if (tid === datensatz.tid) {
                            if (state === 'deleted') {
                                idxFound = idx;
                            } else {
                                // console.log('PRUEFSTATE Found Item ', idx, tid);
                                pruefState[currentItem.entity].pruefResult[idx] = state;
                            }
                            changed = true;
                        }
                    });
                    if (changed && idxFound !== -1) {
                        pruefState[currentItem.entity].pruefResult.splice(idxFound, 1);
                        pruefState[currentItem.entity].pruefTids.splice(idxFound, 1);
                        changed = true;
                    }
                    if (!changed) {
                        pruefState[currentItem.entity].pruefResult.push(state);
                        pruefState[currentItem.entity].pruefTids.push(datensatz.tid);
                        changed = true;
                    }
                }
            }
            if (changed) {
                this.setState({ pruefState });
            }
        }
    }

    setStartjahrDatenerfassung(value: number): void {
        const handle = window.setTimeout(() => {
            if (this.lastHandle === handle) {
                this.setStartjahrDatenerfassungNow(value);
            }
        }, 2000);
        this.lastHandle = handle;
    }

    setStartjahrDatenerfassungNow(value: number): void {
        const data = this.props.data;
        if (Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0) {
            const item: any = {
                tid: data[IDs.ENT_KONFIGURATION][0].tid,
                startjahr_datenerfassung: value
            };
            this.dataService.setData(
                IDs.MOD_ETOOL, IDs.ENT_KONFIGURATION, item, () => this.triggerService.fire('reload', IDs.ENT_KONFIGURATION)
            );
        }
    }

    renderContentStart(): JSX.Element {
        const konfig = this.props.data[IDs.ENT_KONFIGURATION];
        const jahrStartDateneingabe = this.state.startjahr;
        if (konfig.length) {
            if (jahrStartDateneingabe !== this.state.jahrMin) {
                this.setState({ jahrMin: jahrStartDateneingabe });
                if (this.state.jahr < jahrStartDateneingabe) {
                    this.setState({ jahr: jahrStartDateneingabe });
                }
            }
        }
        const pfeil_rechts = require('../../../img/pfeil_rechts.png');
        const disableVeranstaltungen: boolean = !(konfig || []).some((param: any) => param.veranstaltungen_orig === 1);
        return <div>
            {this.renderContentStartInfo()}
            <div className={style.startBox}>
                Bitte wählen Sie das Jahr und den Standort, für das/den die Dateneingabe erfolgen soll:
                <br /><br />
                <DatenauswertungJahrauswahlEinzeln
                    jahrMax={this.state.jahrMax}
                    jahrMin={this.state.jahrMin}
                    // WKETOOL-93 - 447: Das Jahr der Eingabe darf kleiner als das Startjahr sein.
                    jahr={this.state.jahr}
                    // jahrMin={2010}
                    helpKey='gefuehrter_modus_eingabejahr'
                    data={this.props.data}
                    widthLabel={300}
                    widthInput={280}
                    colLabel='#616468'
                    jahrInputStyle={{ marginLeft: 10 }}
                    // noCheck={true}
                    strLabel='Dateneingabe für das Jahr'
                    onJahrChange={(jahr: number) => this.setState({ jahr: +jahr }, () => this.setConfig())}
                />
                <div style={{ width: 280, fontSize: 12, fontWeight: 'normal', fontStyle: 'italic', marginLeft: 315 }}>
                    Hier geben Sie das Kalenderjahr ein, für das Sie jetzt Energiedaten eintragen möchten.
                    <br /> (&nbsp; <img style={{ height: 10 }} src={pfeil_rechts} alt='pfeil_rechts' /> z.B. Jahr 2020: 01.01.2020 - 31.12.2020)
                </div>
                <br />
                <div style={{ padding: 5, boxSizing: 'border-box' }}>
                    <div style={{ width: 310, display: 'inline-block', fontSize: 16, color: '#616468' }}>
                        Standort
                    </div>
                    {this.renderStandortSelect(false, disableVeranstaltungen)}
                    <div style={{ paddingTop: 3, display: 'inline-block', paddingLeft: 5 }}>
                        <WHelpIcon
                            data={this.props.data}
                            styleDivProps={{ display: 'inline-block' }}
                            styleProps={{
                                width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5',
                                verticalAlign: 'top', margin: 0
                            }}
                            label='Hinweise'
                            helpKey='gefuerhter_modus_standort'
                            editBar={true}
                            style={'theme_small'}
                            type={'theme_info'}
                            customElement={'Info'}
                            useTheme
                        />
                    </div>
                </div>
                {!disableVeranstaltungen && <div style={{ padding: 5, boxSizing: 'border-box' }}>
                    <div style={{ width: 310, display: 'inline-block', fontSize: 16, color: '#616468' }}>
                        Veranstaltung
                    </div>
                    {this.renderStandortSelect(true, disableVeranstaltungen)}
                    <div style={{ paddingTop: 3, display: 'inline-block', paddingLeft: 5 }}>
                        <WHelpIcon
                            data={this.props.data}
                            styleDivProps={{ display: 'inline-block' }}
                            styleProps={{
                                width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5',
                                verticalAlign: 'top', margin: 0
                            }}
                            label='Hinweise'
                            helpKey='gefuerhter_modus_standort'
                            editBar={true}
                            style={'theme_small'}
                            type={'theme_info'}
                            customElement={'Info'}
                            useTheme
                        />
                    </div>
                </div>}
                <div style={{ width: 280, fontSize: 12, fontWeight: 'normal', fontStyle: 'italic', marginLeft: 315 }}>
                    Hier wählen Sie den Standort aus, für den Sie anschließend Daten eingeben möchten
                    (beim ersten Aufruf des Tools ist diese Auswahl ausgegraut - sie wird erst aktiviert,
                    wenn bereits mehrere Standorte erfasst wurden).
                </div>
                <br />
                <div style={{ padding: 5, boxSizing: 'border-box' }}>
                    <div style={{ width: 310, display: 'inline-block', fontSize: 16, color: '#616468' }}>
                        &nbsp;
                    </div>
                    <div style={{ display: 'inline-block' }}>
                        <button
                            style={{ margin: 0, width: 280 }}
                            className={style.basic}
                            onClick={this.onClickStart}
                        >
                            Dateneingabe starten
                        </button>
                        <div style={{ width: 280, fontSize: 12, fontWeight: 'normal', fontStyle: 'italic', marginTop: 5 }}>
                            <b>Hinweis:</b> &nbsp;
                            Nach dem Starten der Dateneingabe erfolgt die Speicherung aller Daten automatisch.
                            Navigieren Sie einfach mit dem "<b>Weiter</b>"-Button (Kopfzeile) Schritt für Schritt durch die Eingabe.
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }

    renderContentStartInfo(): JSX.Element {
        const modulSelected: string = this.props.data.MODUL_SELECTED;
        return <>
            {config?.enableVideos &&
                <div
                    className={style.startBox}
                    style={{ textAlign: 'right', width: 700, margin: 0, marginTop: 15, padding: 0, paddingRight: 10, position: 'absolute', backgroundColor: 'transparent', boxShadow: 'none' }}
                >
                    <WVideoIcon
                        videoUrl='/videos/eTool_00_Ueberblick.mp4'
                        title={i18n('E-Tool Aufbau', 'sys')}
                    />
                </div>
            }
            <div
                className={style.startBox}
                style={{ fontWeight: 'normal', color: 'black', marginTop: 5 }}
            >
                {renderText(`start_info_${modulSelected}`, this.props.data)}
            </div>
        </>;
    }

    onClickStart(): void {
        // WKETOOL-93 - 447: Das Jahr der Eingabe darf kleiner als das Startjahr sein.
        if (this.state.jahr <= this.state.jahrMax && this.state.jahr >= 2010) {
            const startIdx: number = this.getStartIndex();
            let currentGliederung = this.state.currentGliederung;
            if (startIdx > 0 && this.state.config[startIdx]) {
                const item = this.state.config[startIdx];
                if (item.gliederung && typeof item.gliederung === 'string') {
                    currentGliederung = +item.gliederung.split('.')[0];
                }
            }
            this.setState({ runState: 'running', runIndex: startIdx, currentGliederung, currentGliederungState: 'open' });
            this.contextService.set('jahr_cockpit', +this.state.jahr);
        } else {
            alert('Bitte geben Sie ein gültiges Jahr ein!');
        }
    }

    getStartIndex(): number {
        const { data } = this.props;
        const konfig = Array.isArray(data[IDs.ENT_KONFIGURATION]) ? data[IDs.ENT_KONFIGURATION][0] : undefined;
        const konfigIdx = (this.state.config || []).findIndex((itm: any) => itm.entity === IDs.ENT_KONFIGURATION);
        const untData = Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) ? data[IDs.ENT_UNTERNEHMENSDATEN][0] : undefined;
        // const untDataIdx = (this.state.config || []).findIndex((itm: any) => itm.entity === IDs.ENT_UNTERNEHMENSDATEN);
        const motivData = (data[IDs.ENT_CFM_MOTIVATION] || []).find((item: any) => item.jahr === this.state.jahr || !item.jahr);
        const motivIdx = (this.state.config || []).findIndex((itm: any) => itm.entity === IDs.ENT_CFM_MOTIVATION);
        let startIdx: number;
        if (konfigIdx >= 0 && (!konfig.datum_bearbeitung || !untData.datum_bearbeitung)) {
            startIdx = konfigIdx;
        }
        if (motivIdx >= 0 && !motivData) {
            startIdx = motivIdx;
        }
        if (!startIdx && startIdx !== 0) {
            // Beginnt mit "2 Datenerfassung" oder "2. Hinweise Energiedatenerfassung".
            if (this.state.mode === 'vsme') {
                startIdx = 0;
            } else {
                startIdx = (this.state.config || []).findIndex((itm: any) => typeof itm.gliederung === 'string' && itm.gliederung.startsWith('2.')) || 0;
            }
        }
        // console.log(startIdx, konfig.datum_bearbeitung, untData.datum_bearbeitung, konfigIdx, motivIdx);
        return startIdx;
    }

    renderContentDone(): JSX.Element {
        if (this.state.mode === 'steuer') {
            // Für "Steuer" müsste hier ein direkter Sprung zur Datenauswertung erfolgen.
            // Auch ohne Info?
            this.contextService.set('jahr_cockpit', this.state.jahr);
            this.setRunStateStart();
            this.props.onRoutingChange({
                path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIESTEUER, [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: 1 },
                jahr: this.state.jahr
            });
            return null;
        }

        const styleButton: React.CSSProperties = { width: 320, height: 45, fontSize: 18 };
        const element: JSX.Element = (
            <div
                className={style.doneBox}
                style={{ ...(this.state.forceChoice ? { textAlign: 'center'/*, marginLeft: 40*/ } : {}) }}
            >
                Die Dateneingabe für das Jahr {this.state.jahr || ''} ist abgeschlossen.
                <br />
                Wie möchten Sie als nächstes  tun?
                <br /><br />
                <button
                    className={style.basic}
                    style={styleButton}
                    onClick={this.setRunStateStart}
                >
                    Weitere Jahre / Standorte eingeben
                </button>
                {['cfm', 'vsme'].indexOf(this.state.mode) === -1 && <>
                    <br />
                    <button
                        className={style.basic}
                        style={styleButton}
                        onClick={() => {
                            if (this.state.forceChoice) {
                                this.setState({ forceChoice: false });
                            }
                            this.contextService.set('jahr_cockpit', this.state.jahr);
                            this.props.onRoutingChange({ path: RoutingIDs.ROUTE_ENERGIE_COCKPIT, jahr: this.state.jahr });
                        }}
                    >
                        Zum Energie-Cockpit
                    </button>
                </>}
                {this.state.mode !== 'vsme' && <>
                    <br />
                    <button
                        className={style.basic}
                        style={styleButton}
                        onClick={() => {
                            if (this.state.forceChoice) {
                                this.setState({ forceChoice: false });
                            }
                            this.contextService.set('jahr_cockpit', this.state.jahr);
                            this.props.onRoutingChange({
                                path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS, [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: 1 },
                                jahr: this.state.jahr
                            });
                        }}
                    >
                        Zur CO₂-Fußabdruck Auswertung
                    </button>
                </>}
            </div>
        );

        if (this.state.forceChoice) {
            return (
                <DialogWrapper2
                    width={-1}
                    verticalAlignCenter
                    canClose={false}
                >
                    {element}
                </DialogWrapper2>
            );
        }

        return element;
    }

    renderModusBeendenAndInfo(): JSX.Element {
        const { dialogMode } = this.props;
        const [progressMin, progressValue, progressMax] = this.getProgress();
        const konfiguration: any = ((this.props.data || {})[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const showVsme: boolean = konfiguration.vsme_orig === 1;
        // const showCfm: boolean = konfiguration.co2_fussabdruck_orig === 1;
        const icon_blatt = require('../../../img/blatt.png');
        const optionsForSelect = this.varianten
            .filter((opt: any, idx: number) => (!showVsme && opt.key === 'vsme')/* || (!showCfm && opt.key === 'cfm')*/ ? false : true)
            .map((opt: any, idx: number) => {
                const option: WFormFieldSelectOption = {
                    index: idx,
                    value: opt.key,
                    label: <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={icon_blatt} style={{ marginRight: 10, height: 15 }} alt='' />
                        {i18n(opt.name, 'sys')}
                    </div>
                };
                return option;
            });
        const optionSelected = optionsForSelect.find((opt) => opt.value === this.state.mode);
        const defaultStyle = { minHeight: 1, height: 30, padding: '0 5px' };
        return !dialogMode ?
            <div
                style={{
                    fontSize: 12, textAlign: 'center', backgroundColor: 'inherit', marginTop: -5,
                    ...(this.isAdmin && this.state.runState === 'start' && { marginBottom: 21 }),
                    ...(!this.isAdmin && { marginBottom: 15 }), paddingTop: 5, display: 'none' /* 'flex' */, flexWrap: 'wrap', position: 'sticky',
                    top: -5
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div style={{ fontSize: 16, width: 240, marginTop: 7 }}>
                        <Select
                            placeholder='Auswahl Modul'
                            options={optionsForSelect}
                            value={optionSelected}
                            onChange={(event: any) => {
                                const mode = event.value;
                                if (mode !== this.state.mode) {
                                    this.setState({ mode }, () => {
                                        if (typeof this.props.data.MODUL_ON_SELECT === 'function') {
                                            this.props.data.MODUL_ON_SELECT(mode);
                                        }
                                    });
                                }
                            }}
                            styles={{
                                option: (provided: any, state: any) => { return { ...provided, ...defaultStyle, padding: 5, height: '100%' }; },
                                control: (provided: any, state: any) => { return { ...provided, ...defaultStyle }; },
                                valueContainer: (provided: any, state: any) => { return { ...provided, ...defaultStyle }; },
                                indicatorsContainer: (provided: any, state: any) => { return { ...provided, ...defaultStyle, width: 30 }; }
                            }}
                        />
                    </div>
                    <div style={{ paddingTop: 5, paddingLeft: 5 }}>
                        <WHelpIcon
                            data={this.props.data}
                            styleDivProps={{ display: 'inline-block' }}
                            styleProps={{
                                width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5',
                                verticalAlign: 'top', margin: 0
                            }}
                            label='Hinweise'
                            helpKey='assistent_auswahl_modul'
                            editBar={true}
                            style={'theme_small'}
                            type={'theme_info'}
                            customElement={'Info'}
                            useTheme
                        />
                    </div>
                </div>
                {this.isAdmin && this.state.runState !== 'start' &&
                    <ProgressBar
                        colors={{ 0: '#0a0' }}
                        // colors={{ 0: '#a00', 25: '#ff0', 75: '#0a0' }}
                        max={progressMax}
                        min={progressMin}
                        style={{
                            lineHeight: 1.2, backgroundColor: 'white', width: 276, marginTop: 1, marginBottom: 4, border: '1px solid #aaa',
                            borderRadius: 3
                        }}
                        value={progressValue}
                    />
                }
            </div>
            : <div style={{ marginBottom: 62 }}></div>;
    }

    renderStandortSelect(veranstaltungen: boolean, hideZeroOption: boolean): JSX.Element {
        const standorte = this.props.data[IDs.ENT_STANDORT].filter((item: any) => (!veranstaltungen && +item.energiedaten_erfassen_orig === 1
            && +item.standort_typ_tid_orig !== 5 && +item.standort_typ_tid_orig !== 6) ||
            (veranstaltungen && (+item.standort_typ_tid_orig === 5 || +item.standort_typ_tid_orig === 6)));
        // console.log('STANDORTE: ', standorte);
        if (!standorte) {
            return <select disabled={true}><option>Nicht verfügbar</option></select>;
        }
        if (standorte.length > 0 && !this.state.standortSelected) {
            window.setTimeout(() => {
                this.setState({ standortSelected: standorte[0] }, () => this.setConfig());
            }, 100);
        }
        return (
            <select
                disabled={(this.props.data[IDs.ENT_STANDORT] || []).length < 2}
                style={{ maxWidth: 280, width: 280 }}
                value={this.state.standortSelected ? this.state.standortSelected.tid : undefined}
                onChange={(evt: any) => {
                    const standortSelected = standorte.find((s: any) => s.tid + '' === evt.target.value + '');
                    this.setState({ standortSelected }, () => this.setConfig());
                }}
            >
                {!hideZeroOption && <option>{i18n('keine Auswahl', 'sys')}</option>}
                {standorte.map((standort: any, idx: number) =>
                    <option key={`standort-${idx}`} value={standort.tid}>
                        {standort.name}
                    </option>
                )}
            </select>
        );
    }

    setContextKey(item: AssistentItem): void {
        if (!(this.routing || {}).tid) {
            return;
        }
        const contextKey: string = AssistentEntityForm.getContextKey(item, this.state.jahr, (this.state.standortSelected || {}).tid);
        this.contextService.set(contextKey, this.routing.tid);
    }

    storeScrollTop(): void {
        let dom: any = document.getElementById(this.domId) as HTMLDivElement;
        if (dom) {
            const scrollTop: any = {};
            if (dom.parentElement.scrollTop) {
                scrollTop.parent = dom.parentElement.scrollTop;
            }
            if (dom.children && dom.children[1] && dom.children[1].children && dom.children[1].children[1]) {
                scrollTop.child = dom.children[1].children[1].scrollTop;
            }
            this.scrollTop = scrollTop;
        }
    }

    restoreScrollTop(): void {
        let dom: any = document.getElementById(this.domId) as HTMLDivElement;
        const scrollTop = this.scrollTop;
        if (dom && scrollTop) {
            if (scrollTop.parent && dom.parentElement.scrollTop) {
                dom.parentElement.scrollTop = scrollTop.parent;
            }
            if (scrollTop.child && dom.children && dom.children[1] && dom.children[1].children && dom.children[1].children[1]) {
                dom.children[1].children[1].scrollTop = scrollTop.child;
            }
        }
    }

    storeMenueScrollTop(): void {
        let domM: any = document.getElementById(this.domIdMenue) as HTMLDivElement;
        if (domM) {
            this.scrollTopMenue = domM.scrollTop;
        }
    }

    restoreMenueScrollTop(): void {
        let domM: any = document.getElementById(this.domIdMenue) as HTMLDivElement;
        if (domM && this.scrollTopMenue) {
            domM.scrollTop = this.scrollTopMenue;
            // Nur einmal verwendbar
            this.scrollTopMenue = null;
        }
    }

    setMenueNodeTitle(ref: any, title: string): void {
        if (!ref) {
            return;
        }
        const node: HTMLElement = ref.children.length && ref.children[0].children.length ? ref.children[0].children[0] : {};
        if (node.offsetWidth < node.scrollWidth && node.title !== title) {
            node.title = title;
        } else if (node.offsetWidth === node.scrollWidth && node.title) {
            node.removeAttribute('title');
        }
    }

    onFormReady(): void {
        // WAEW-327 Bugfix Problem mit "springenden Daten" im geführten Modus
        this.restoreScrollTop();
        setTimeout(this.restoreScrollTop, 0);
        setTimeout(this.restoreScrollTop, 50);
        setTimeout(this.restoreScrollTop, 100);
        setTimeout(this.restoreScrollTop, 200);
    }

    getCollapsibleGroups(group: string) {
        let groups = [group];
        const recursiveGroups = (this.state.config || []).filter((c: any) => c.group && group && c.group === group && c.collapsible && c.collapsible !== group).map((c: any) => c.collapsible);
        if (recursiveGroups.length > 0) {
            recursiveGroups.forEach((rGrp: string) => {
                const rGrps = this.getCollapsibleGroups(rGrp);
                groups = groups.concat(rGrps)
            });
        }
        return groups;
    }

    getVideoForItem(item: any): any {
        // console.log('CurrentItem:', item);
        if (item?.entity === 'konfiguration') {
            return { url: 'videos/eTool_01_Konfiguration.mp4', name: 'Konfiguration' }
        } else if (['energiedaten_strom','energiedaten_waerme'].indexOf(item?.entity) !== -1) {
            return { url: 'videos/eTool_03_Energiedatenerfassung.mp4', name: 'Energiedatenerfassung' };
        } else if(item?.entity === 'energiedaten_kraftstoffe') {
            return { url: 'videos/eTool_04_Fahrzeugerfassung.mp4', name: 'Fahrzeugerfassung' };
        } else if(item?.entity === 'betriebsdaten') {
            return { url: 'videos/eTool_08_BWL-Daten.mp4', name: 'Betriebsdaten' };
        } else if(item?.name === 'Energiedaten' && !item?.entity) {
            return { url: 'videos/eTool_03_Energiedatenerfassung.mp4', name: 'Energiedatenerfassung' };
        } 
    }
}
